export default __webpack_public_path__ + "static/media/reportSales.0245d5b6.png";